import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const UnauthenticatedRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);

  return isAuthenticated === false ? (
    children
  ) : (
    <Navigate to="/admin/users" replace />
  );
};

UnauthenticatedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UnauthenticatedRoute;
